import { createSlice } from "@reduxjs/toolkit";
import { getUser, exportUsers } from "./Utils/userUtils";

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "",
        "page": "",
    },
    users: [],
    pagination: {},
    loading: false,
    error: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getUser
            .addCase(getUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUser.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle exportUsers
            .addCase(exportUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(exportUsers.fulfilled, (state) => {
                state.loading = false;
                // No need to update state on successful export
            })
            .addCase(exportUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFilters, resetFilters } = userSlice.actions;
export default userSlice.reducer;